<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <!-- 群成员列表 - 参考设计图横向展示 -->

    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item v-if="formType === 2" :label="$t('群成员')">
        <div class="member-list-wrapper">
          <div class="member-list">
            <div
              v-for="(member, index) in memberList"
              :key="member.id || member.userId"
              class="member-item"
            >
              <div class="member-avatar-wrap">
                <img
                  v-if="member.avatar"
                  :src="member.avatar"
                  class="member-avatar"
                  alt=""
                />
                <div v-else class="member-avatar member-avatar-placeholder">
                  {{ ((member.nickName || member.nick_name) || '').charAt(0) || '?' }}
                </div>
              </div>
              <div class="member-name" :title="member.nickName || member.nick_name">{{ formatMemberName(member.nickName || member.nick_name) }}</div>
            </div>
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item prop="groupName" >
        <span slot="label" ><a-tooltip>{{ $t('群名称') }}<template slot="title">{{ $t('群名称，最长8个中文字符') }}</template></a-tooltip> </span>
        <a-input v-model="form.groupName" :maxLength="100" :placeholder="$t('请输入')+'群名称，最长8个中文字符'" />
      </a-form-model-item>
      <a-form-model-item prop="introduction" >
        <span slot="label" ><a-tooltip>{{ $t('群简介') }}<template slot="title">{{ $t('群简介，最长64个中文字符') }}</template></a-tooltip> </span>
        <a-input v-model="form.introduction" :maxLength="64" :placeholder="$t('请输入')+'群简介，最长64个中文字符'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="notification" >
        <span slot="label" ><a-tooltip>{{ $t('群公告') }}<template slot="title">{{ $t('群公告，最长100个中文字符') }}</template></a-tooltip> </span>
        <a-input type="textarea" v-model="form.notification" :maxLength="100" :placeholder="$t('请输入')+'群公告，最长100个中文字符'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="avatar" >
        <span slot="label" ><a-tooltip>{{ $t('群头像') }}<template slot="title">{{ $t('群头像') }}</template></a-tooltip> </span>
        <oss-upload-single :height="100" :width="100" v-model="form.avatar" prefix="activity" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="isDismiss" >
        <span slot="label" ><a-tooltip>{{ $t('是否解散') }}<template slot="title">{{ $t('是否解散') }}</template></a-tooltip> </span>
        <a-radio-group v-model="form.isDismiss" disabled button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="num" >
        <span slot="label" ><a-tooltip>{{ $t('群人数') }}<template slot="title">{{ $t('群人数') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.num" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'群人数'" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCommunityChatGroup, addCommunityChatGroup, updateCommunityChatGroup } from '@/api/community/chatGroup'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssUploadSingle,
    CustomDictTag,
    LocaleFieldButton
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      memberList: [],
      // 表单参数
      form: {
        id: null,
        ownerId: null,
        groupType: null,
        groupName: null,
        introduction: null,
        notification: null,
        avatar: null,
        applyType: null,
        isMute: null,
        isDismiss: null,
        num: null,
        remark: null,
        localeFieldMap: {}
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        ownerId: [{ required: true, message: this.$t('群主id') + this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.memberList = []
      this.form = {
        id: null,
        ownerId: null,
        groupType: null,
        groupName: null,
        introduction: null,
        notification: null,
        avatar: null,
        applyType: null,
        isMute: null,
        isDismiss: null,
        num: null,
        remark: null,
        localeFieldMap: {}
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityChatGroup({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
        this.memberList = response.data.memberList
      })
    },
    /** 格式化成员名称，过长显示省略 */
    formatMemberName (name) {
      if (!name) return '-'
      return name.length > 5 ? name.substring(0, 5) + '...' : name
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityChatGroup(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* 群成员列表 - 图二横向卡片样式 */
.member-list-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 12px 0;
}

.member-list {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 20px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 6px;
  align-items: flex-start;

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 3px;
  }
}

.member-item {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 64px;
}

.member-avatar-wrap {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f5f5;
}

.member-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;

  &.member-avatar-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #999;
    background: linear-gradient(135deg, #e8e8e8 0%, #f0f0f0 100%);
  }
}

.member-name {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
  width: 100%;
  max-width: 64px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
